const Bank = ['$resource', 
    function ($resource) {
        return $resource(API_URL + '/api/1.0/banks/:id/', { id: '@id'},{
                'patch': { method:'PATCH' }
        });
    }
]

export { Bank };